export default __webpack_public_path__ + "static/media/lossan.c577f00d.jpg";